import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../../assets/image/logo.png";
import { studentNav } from "../config/studentNav";

// Self-contained StudentPortal sidebar. Deliberately NOT sharing code OR
// class names with src/containers/TheSidebar.js (the staff admin sidebar).
// Earlier this used the shared `sidebar-main`/`sidebar-brand`/`sideBarNav`
// class names for convenience, but main.css defines real, unscoped rules on
// those exact names for the staff layout (e.g. `.sidebar-brand { position:
// fixed; ... }`, `.sidebar-main { border-radius: 0 0 .35rem 0 }`, `.sideBarNav
// span { display: none }` on tablet widths) — those rules silently leaked in
// here too and broke the logo/sidebar rendering. Every class below is
// StudentPortal-only (`sp-*` / `student-sidebar-*`) so nothing from the
// staff design system can apply to it, confirmed via `src/main.css`.
const StudentSidebar = () => {
  // Floating tooltip state (see StudentPortal.css's .student-sidebar-tooltip
  // for why this is a JS-positioned `position: fixed` element rather than a
  // pseudo-element on the link itself — the link's own scrolling ancestors
  // would otherwise clip it as you move between items in the collapsed,
  // icon-only sidebar).
  const [tooltip, setTooltip] = useState(null);

  const showTooltip = (event, label) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltip({ label, top: rect.top + rect.height / 2, left: rect.right + 14 });
  };

  const hideTooltip = () => setTooltip(null);

  return (
    <div className="student-sidebar">
      <Link to="/student-portal/dashboard" className="student-sidebar-brand">
        <span className="student-sidebar-brand-logo">
          <img src={logo} alt="" />
        </span>
        <span className="brand-title">Student Portal</span>
      </Link>
      <ul className="student-sidebar-list">
        {studentNav.map((navItem) => (
          <li key={navItem.to} className="student-sidebar-item">
            <NavLink
              aria-label={navItem.label}
              to={navItem.to}
              className={({ isActive }) =>
                `student-sidebar-link${isActive ? " active" : ""}`
              }
              onMouseEnter={(event) => showTooltip(event, navItem.label)}
              onMouseLeave={hideTooltip}
              onFocus={(event) => showTooltip(event, navItem.label)}
              onBlur={hideTooltip}
            >
              {navItem.name}
            </NavLink>
          </li>
        ))}
      </ul>

      {tooltip && (
        <div
          className="student-sidebar-tooltip"
          style={{ top: tooltip.top, left: tooltip.left }}
        >
          {tooltip.label}
        </div>
      )}
    </div>
  );
};

export default StudentSidebar;
